var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreatmentGhEclipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1860,
    height: 406,
    viewBox: "0 0 1860 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 859,
    cy: -1048,
    r: 1454,
    fill: "#CA5751"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1391,
    cy: -1026,
    r: 1349,
    fill: "#5F51CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentGhEclipse);
export default __webpack_public_path__ + "static/media/treatmentGHEclipse.f44595354824a553738c5f5369b578ca.svg";
export { ForwardRef as ReactComponent };